import { Controller } from "@hotwired/stimulus"

// Le azioni del riquadro «Visura camerale» (components/VisuraCamerale.js, 31a5bd1): «Carica la visura (PDF)» e
// «Carica il bilancio (PDF)» aprono la scelta del file nascosta (input.current.click()) e la scelta invia subito il
// form; durante un caricamento o la lettura dal fornitore (busy) i pulsanti sono spenti e quello della visura dice
// «Lettura…»; alla fine tornano come prima e la scelta del file si svuota (input.current.value = "").
export default class extends Controller {
  static targets = ["pulsante", "carica"]

  scegli(event) {
    event.currentTarget.closest("form")?.querySelector("input[type=file]")?.click()
  }

  invia(event) {
    const input = event.currentTarget
    if (!input.files?.length) return
    input.form.requestSubmit()
  }

  inizia() {
    this.pulsanteTargets.forEach((b) => { b.disabled = true })
    if (this.hasCaricaTarget) {
      this.etichetta = this.caricaTarget.textContent
      this.caricaTarget.textContent = "Lettura…"
    }
  }

  fine(event) {
    this.pulsanteTargets.forEach((b) => { b.disabled = false })
    if (this.hasCaricaTarget && this.etichetta !== undefined) this.caricaTarget.textContent = this.etichetta
    const input = event.target.querySelector?.("input[type=file]")
    if (input) input.value = ""
  }
}
